"use client";

import { useEffect } from "react";

export default function ScrollRevealInit() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    // Observe all reveal elements
    document.querySelectorAll(".reveal, .reveal-left, .reveal-right")?.forEach((el) => {
      observer?.observe(el);
    });

    return () => observer?.disconnect();
  }, []);

  return null;
}